/**
 * 金額をN万円単位で表示する
 * @param price
 * @returns {number}
 */
export const viewPrice = (price) => price / 10000;
